import { createStorage } from './cache/index';
const { get, set, remove } = createStorage();
export function setToken(token: string) {
  set('token', token);
}
export function getToken(): string {
  return get('token');
}
export function deleteToken() {
  remove('token');
}
export function setRefreshToken(token: string) {
  set('refreshToken', token);
}
export function getRefreshToken(): string {
  return get('refreshToken');
}
export function deleteRefreshToken() {
  remove('refreshToken');
}
export function setUserTabData(tabs: Array<String>) {
  set('userTabData', tabs);
}
export function getUserTabData(): string {
  return get('userTabData');
}
export function deleteUserTabData() {
  remove('userTabData');
}
export function setGptUserNo(gptUserNo: string) {
  return set('gptUserNo', gptUserNo);
}

export function getGptUserNo() {
  return get('gptUserNo');
}
export function removeGptUserNo() {
  return remove('gptUserNo');
}
